export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0a0a0a] py-10">
    <p className="text-center text-xs text-zinc-500 px-4">
      © {new Date().getFullYear()} Glow &amp; Bling — Home of Bourne For Bling, Bourne To Glow, and Lani Lemonade.
    </p>
  </footer>
);

export default Footer;
